export default __webpack_public_path__ + "static/media/Logo.c2a1ef3d.svg";